import { useState, type FormEvent } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { authEnabled, confirmForgotPassword, translateCognitoError } from '../../auth/auth';
import { sanitizeReturnTo, withReturnTo } from '../../lib/returnTo';

export default function ResetConfirm() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  // 再設定画面から引き継いだ復帰先。再設定完了後のログイン画面へさらに引き継ぐ。
  const from = sanitizeReturnTo(searchParams.get('from'));
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  // 認証未設定（モックモード）ではこの画面自体を表示しない。
  if (!authEnabled) return <Navigate to="/" replace />;
  // メールアドレスが無いとどのユーザーの再設定かわからないため、最初からやり直させる。
  if (!email) return <Navigate to={withReturnTo('/reset', from)} replace />;

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await confirmForgotPassword(email, code, newPassword);
      navigate(withReturnTo('/login?reset=success', from));
    } catch (err) {
      setError(translateCognitoError(err));
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-card__title">新しいパスワードの設定</h1>
        <p className="auth-card__lead">
          {email} に届いた確認コードと、新しいパスワードを入力してください。
        </p>

        <form className="auth-form" onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="code">確認コード</label>
            <input
              id="code"
              inputMode="numeric"
              autoComplete="one-time-code"
              required
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="newPassword">新しいパスワード</label>
            <input
              id="newPassword"
              type="password"
              autoComplete="new-password"
              required
              minLength={8}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <div className="auth-form__hint">8 文字以上で入力してください。</div>
          </div>

          {error && <div className="auth-form__error">{error}</div>}

          <button type="submit" className="btn btn--primary" disabled={busy}>
            {busy ? '処理中…' : 'パスワードを再設定'}
          </button>
        </form>

        <div className="auth-form__links">
          <Link to={withReturnTo('/login', from)}>ログイン画面へ戻る</Link>
        </div>
      </div>
    </div>
  );
}
